// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"SubscriptionForm_formContainer__1q-YH","form":"SubscriptionForm_form__1t3Yw","tryWSBtn":"SubscriptionForm_tryWSBtn__o1dVR"};